import { Table, Text } from "@radix-ui/themes";
import React from "react";

const RadixTable = ({
  header,
  data,
  onDelete = "",
  DropDownComp = "",
  approve = "",
}) => {
  return (
    <>
      {data.length ? (
        <>
          <Table.Header>
            <Table.Row>
              {header.map((data, i) => (
                <React.Fragment key={i}>
                  <Table.ColumnHeaderCell>
                    {data}
                  </Table.ColumnHeaderCell>
                </React.Fragment>
              ))}
              <Table.ColumnHeaderCell>Options</Table.ColumnHeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {data.map((bodyData, i) => (
              <Table.Row key={i}>
                {bodyData["cellData"].map((cellData, index) => (
                  <Table.Cell key={index}>{cellData}</Table.Cell>
                ))}
                {DropDownComp !== "" ? (
                  <DropDownComp
                    approve={approve}
                    data={bodyData}
                    index={i}
                    onDelete={onDelete}
                  />
                ) : (
                  <Table.Cell style={{ cursor: "pointer" }}>...</Table.Cell>
                )}
              </Table.Row>
            ))}
          </Table.Body>
        </>
      ) : (
        <>
          <Text weight="bold" as="div" m="4" align="center" size="6">
            {" "}
            No Data Found
          </Text>
        </>
      )}
    </>
  );
};

export default RadixTable;
